<template>
  <div
    class="h-full pt-24 md:h-screen md:pt-16 dark:bg-black lg:px-0 md:px-4"
    id="resume-page"
  >
    <div data-aos="fade-up">
      <div class="flex-col justify-center hidden mx-auto md:flex maxWidth">
        <div class="flex flex-col items-end">
          <h1 class="text-6xl font-bold textBlue">Resume</h1>
          <p
            class="text-xl font-normal text-left dark:text-gray-300"
          >
            My journey
          </p>
        </div>
        <div
          v-for="resume in resumes"
          :key="resume.id"
          class="flex justify-center focus-within:"
        >
          <div class="grid grid-cols-6 md:grid">
            <div class="">
              <div class="w-full my-4">
                <h3
                  class="mb-1 text-xl font-bold dark:text-gray-300"
                >
                  {{ resume.place }}
                </h3>
                <p
                  class="w-full leading-tight text-justify dark:text-gray-300"
                >
                  {{ resume.date }}
                </p>
              </div>
            </div>
            <div class="flex md:contents">
              <div class="relative col-start-2 col-end-4 mr-10 md:mx-auto">
                <div class="flex items-center justify-center w-6 h-full">
                  <div
                    class="w-1 h-full bg-black pointer-events-none dark:bg-gray-300"
                  ></div>
                </div>
                <div
                  class="absolute w-6 h-6 text-center rounded-full shadow -mt-9 dot top-1/2"
                ></div>
              </div>
              <div class="w-full col-start-4 col-end-12 my-4 text-left">
                <h3
                  class="mb-1 text-xl font-bold dark:text-gray-300"
                >
                  {{ resume.occupation }}
                </h3>
                <p
                  class="leading-tight text-justify dark:text-gray-300"
                >
                  {{ resume.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col md:hidden">
        <div class="flex flex-col items-center justify-center">
          <h1 class="text-6xl font-bold textBlue">Resume</h1>
          <p class="text-3xl font-normal dark:text-gray-300">
            My journey
          </p>
        </div>
        <div
          v-for="resume in resumes"
          :key="resume.id"
          class="flex justify-center"
        >
          <div class="ml-3 md:grid">
            <div class="flex md:contents">
              <div class="relative mr-3 md:mx-auto">
                <div class="flex items-center justify-center w-6 h-full">
                  <div
                    class="w-1 h-full bg-black pointer-events-none dark:bg-white"
                  ></div>
                </div>
                <div
                  class="absolute w-6 h-6 -mt-16 text-center rounded-full shadow dot top-1/2"
                ></div>
              </div>
              <div class="w-full my-4 text-left">
                <h3
                  class="text-xl font-bold leading-3 dark:text-gray-300"
                >
                  {{ resume.occupation }}
                </h3>
                <h3
                  class="text-xl font-bold dark:text-gray-300"
                >
                  {{ resume.place }}
                </h3>
                <p
                  class="w-full pt-2 font-semibold leading-tight text-justify md:font-normal dark:text-gray-300"
                >
                  {{ resume.date }}
                </p>
                <p class="tracking-tight dark:text-gray-300">
                  {{ resume.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../components/Loader.vue";
import AOS from "aos";
import { onMounted } from "vue";
export default {
  name: "Resume",
  data() {
    return {
      resumes: [],
      loading: false,
    };
  },
  components: { Loader },
  mounted() {
    this.loading = true;
    fetch("https://port-backend-bice.vercel.app/resume")
      .then((res) => res.json())
      .then((data) => {
        this.resumes = data;
        this.loading = false;
      })
      .catch((err) => console.log(err.message));
  },
  setup() {
    onMounted(() => {
      AOS.init();
    });
  },
};
</script>

<style scoped>
.dot {
  background: #1e90ff;
}
/* 
.line {
  background: #101010;
} */
</style>
